import { SxProps } from '@mui/material'
import { calendarDimensions, dateRangePickerClasses } from './DateRangePicker.data'
import { STYLE_UNITS } from '@/styles'

interface DateRangePickerStyles {
  wrapper: SxProps
  body: SxProps
  weeksWrapper: SxProps
  weekDay: SxProps
  daysWrapper: SxProps
}

const calendarWidth =
  calendarDimensions.dayButtonSize * 7 +
  calendarDimensions.paddingMultiplier * STYLE_UNITS.SPACING_MULTIPLIER * 2

export const dateRangePickerStyles: DateRangePickerStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    p: calendarDimensions.paddingMultiplier,
    width: calendarWidth,

    [`&.${dateRangePickerClasses.fullWidth}`]: {
      width: '100%',
      minWidth: calendarWidth,
    },
  },
  body: { display: 'flex', flexDirection: 'column', gap: 0.5 },
  weeksWrapper: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' },
  weekDay: {
    typography: 'textSm',
    color: 'text.secondary700',
    textAlign: 'center',
  },
  daysWrapper: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', rowGap: 0.5 },
}
